export default ['768px', '1024px', '1200px']
